export const getApiConfig = (queryClient, mfeConfig, enabled, additionalQueryOptions) => {
    return {
        config: mfeConfig,
        queryOptions: {
            ...queryClient.getQueryDefaults(),
            enabled,
            ...additionalQueryOptions
        }
    };
};
